import { render, staticRenderFns } from "./get_otoplug.vue?vue&type=template&id=8c0594d0&"
import script from "./get_otoplug.vue?vue&type=script&lang=js&"
export * from "./get_otoplug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports